module.exports = __webpack_public_path__ + "static/media/durotar.3a5052c2.jpg";